import { Backdrop, CircularProgress } from "@mui/material";
import { useContext } from "react";
import { LoaderContext } from "../../contexts";

export default function LoaderFC() {
    const { open } = useContext(LoaderContext);

    return (
        <Backdrop
            sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}
